export type Sides = [top: number, right: number, bottom: number, left: number];

export const SideNames = ["Top", "Right", "Bottom", "Left"] as const;

/** The four sides a CSS padding or margin gives, from the one to four values it was written with; none for empty. */
export function parseSpacing(value: string | null | undefined): Sides | null {
  const tokens = (value ?? "").trim().split(/\s+/).filter(Boolean).slice(0, 4);

  if (tokens.length === 0) {
    return null;
  }

  const [top, right, bottom, left] = tokens.map((token) => parseFloat(token) || 0);
  const sideRight = right ?? top;

  return [top, sideRight, bottom ?? top, left ?? sideRight];
}

const px = (amount: number) => (amount === 0 ? "0" : `${amount}px`);

/** The shortest CSS that gives these sides: one value, two, three or four. */
export function formatSpacing([top, right, bottom, left]: Sides): string {
  if (top === right && right === bottom && bottom === left) {
    return px(top);
  }

  if (top === bottom && right === left) {
    return `${px(top)} ${px(right)}`;
  }

  return left === right
    ? `${px(top)} ${px(right)} ${px(bottom)}`
    : `${px(top)} ${px(right)} ${px(bottom)} ${px(left)}`;
}
